import { useTranslation } from "react-i18next";
import { CheckInRateCard } from "./components/check-in-rate-card";
import { ReservationCancellationsCard } from "./components/reservation-cancellations-card";
import { CollaboratorsCard } from "./components/collaborators-card";
import { useAuth } from "@/core/components/auth/store/auth";
import { useDashboardFilters } from "@/dashboard/store/useDashboardFilters";
import { DashboardSection } from "@/dashboard/components/dashboard-ds";

// Figma 6037:4521: 3 cards por linha (gap 20); auto-fit c/ min 280px quebra
// de linha quando sidebar + painel do agente estreitam o conteúdo.
const CARDS_GRID =
  "grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-5 items-stretch";

export function DashboardSpaceUsageCards() {
  const [t] = useTranslation(["dashboard"]);
  const { filters } = useDashboardFilters();
  const { userInfo } = useAuth();

  const companyId = userInfo?.league?.id;

  if (!companyId) {
    return (
      <DashboardSection
        title={t("dashboard-space-usage-title", "Indicadores de uso")}
        data-testid="dashboard-space-usage"
      >
        <div className={CARDS_GRID}>
          <div className="h-64 bg-gray-200 rounded-2xl animate-pulse" />
          <div className="h-64 bg-gray-200 rounded-3xl animate-pulse" />
          <div className="h-64 bg-gray-200 rounded-3xl animate-pulse" />
        </div>
      </DashboardSection>
    );
  }

  return (
    <DashboardSection
      title={t("dashboard-space-usage-title", "Indicadores de uso")}
      data-testid="dashboard-space-usage"
    >
      <div className={CARDS_GRID}>
        <CollaboratorsCard />

        <CheckInRateCard
          startDate={filters.startDate}
          endDate={filters.endDate}
          companyId={companyId}
          cities={filters.cities?.map((c) => c.name) || null}
          spaces={filters.spaces?.map((s) => Number(s.id)) || null}
          users={
            (filters.users
              ?.map((u) => u.user?.id)
              .filter(Boolean) as number[]) || null
          }
          status={filters.status || null}
          types={filters.type || null}
          group_id={filters.group_id || null}
        />
        <ReservationCancellationsCard
          startDate={filters.startDate}
          endDate={filters.endDate}
          companyId={companyId}
          cities={filters.cities?.map((c) => c.name) || null}
          spaces={filters.spaces?.map((s) => Number(s.id)) || null}
          users={
            (filters.users
              ?.map((u) => u.user?.id)
              .filter(Boolean) as number[]) || null
          }
          status={filters.status || null}
          types={filters.type || null}
          group_id={filters.group_id || null}
        />
      </div>
    </DashboardSection>
  );
}
